'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../helper/assetsHelper');
var i18nHelper = require('../helper/i18n');

var NavigationBar = React.createClass({
  propTypes: {
    onOpenNext: React.PropTypes.func.isRequired,
    onOpenPrev: React.PropTypes.func.isRequired,
    onOpenHome: React.PropTypes.func.isRequired,
    onPlayback: React.PropTypes.func.isRequired,
    controlPanel: React.PropTypes.bool.isRequired,
    onTogglePanelVisibility: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      top: 50,
      right: 50,
      moved: false,
      expand: true
    };
  },
  render: function () {
    var style = {
      top: this.state.top,
      right: this.state.right
    };
    var panelStyle = {};
    if (!this.state.expand) {
      panelStyle.borderRight = 'none';
    } else {
      panelStyle.borderRight = '1px solid #666';
    }
    var expandIcon = this.state.expand ? assetsHelper.getAsset('shrink.png') : assetsHelper.getAsset('blowup.png');
    return (
      <div className="navigation-bar" style={style} onMouseDown={this.onTitleClick}>
        <div className="navigation-bar-title" onDoubleClick={this.onToggleExpand}>
          <img onClick={this.onToggleExpand} width="11" height="11"
               src={expandIcon}/>
        </div>
        <div className="navigation-actions">
          {
            this.props.controlPanel &&
            <div className="panel" style={panelStyle}>
            <span className="action" onClick={this.props.onTogglePanelVisibility}>
              <img src={assetsHelper.getAsset('menu.png')} alt=""/>
              <span className="tooltip">{i18nHelper.get('SETTINGS')}</span>
            </span>
            </div>
          }
          { this.state.expand &&
          <div className="navs">
            <span className="action" onClick={this.props.onOpenHome}>
              <img src={assetsHelper.getAsset('home.png')}/>
              <span className="tooltip">{i18nHelper.get('HOME')}</span>
            </span>
            <span className="action" onClick={this.props.onOpenPrev}>
              <img src={assetsHelper.getAsset('prev.png')}/>
              <span className="tooltip">{i18nHelper.get('PREV')}</span>
            </span>
            <span className="action" onClick={this.props.onOpenNext}>
              <img src={assetsHelper.getAsset('next.png')}/>
              <span className="tooltip">{i18nHelper.get('NEXT')}</span>
            </span>
            <span className="action" onClick={this.props.onPlayback}>
              <img src={assetsHelper.getAsset('playback.png')}/>
              <span className="tooltip">{i18nHelper.get('PLAYBACK')}</span>
            </span>
          </div>
          }
        </div>
      </div>
    );
  },
  onToggleExpand: function () {
    this.setState({
      expand: !this.state.expand
    });
  },
  onTitleClick: function (e) {
    this.startPosition = {
      top: this.state.top,
      right: this.state.right
    };
    document.addEventListener('mousemove', this.onMove);
    document.addEventListener('mouseup', this.onEnd);
    e.stopPropagation();
    e.preventDefault();
  },
  onMove: function (e) {
    if (!this.startInfo) {
      this.startInfo = {
        x: e.pageX,
        y: e.pageY
      };
      return;
    }
    var deltaX = e.pageX - this.startInfo.x;
    var deltaY = e.pageY - this.startInfo.y;
    var dom = ReactDOM.findDOMNode(this);
    dom.style.top = this.startPosition.top + deltaY + 'px';
    dom.style.right = this.startPosition.right - deltaX + 'px';
    this.deltaX = deltaX;
    this.deltaY = deltaY;
    e.stopPropagation();
    e.preventDefault();
  },
  onEnd: function (e) {
    if (this.deltaX || this.deltaY) {
      this.setState({
        top: Math.max(0, this.startPosition.top + this.deltaY),
        right: Math.max(0, this.startPosition.right - this.deltaX)
      });
      this.startInfo = null;
      this.deltaX = 0;
      this.deltaY = 0;
    }
    e.stopPropagation();
    e.preventDefault();
    document.removeEventListener('mousemove', this.onMove);
    document.removeEventListener('mouseup', this.onEnd);
  }
});

module.exports = NavigationBar;


/** WEBPACK FOOTER **
 ** ./src/views/NavigationBar.jsx
 **/